// extracted by mini-css-extract-plugin
export default {"root":"cCvDB","menu-item":"_20l1q","menuItem":"_20l1q","selected":"Ej-mm"};